import axios from 'axios';
// @ts-ignore
import { FetchCountryName } from '../Utils/CountryUtility';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const personas = [
  {
    id: 'Nature',
    label: 'Nature Lover',
    emoji: '🌿',
    explanation: 'Mountains, forests, scenic landscapes, hiking trails and eco-parks',
  },
  {
    id: 'Architecture',
    label: 'Architecture Explorer',
    emoji: '🏛️',
    explanation: 'Historic buildings, modern design, cityscapes, iconic structures',
  },
  {
    id: 'Art',
    label: 'Art Enthusiast',
    emoji: '🎨',
    explanation: 'Galleries, street art, performances, cultural festivals',
  },
  {
    id: 'History',
    label: 'History Buff',
    emoji: '📜',
    explanation: 'Museums, ruins, heritage sites, ancient cities, historical landmarks',
  },
  {
    id: 'Adventure',
    label: 'Adventure Seeker',
    emoji: '🧗',
    explanation: 'Climbing, rafting, zip-lining, paragliding, desert safaris, etc...',
  },
  {
    id: 'Water',
    label: 'Waterscape Wanderer',
    emoji: '🌊',
    explanation: 'Beaches, cenotes, lakes, waterfalls, rivers, hot springs and coastal escapes',
  },
  {
    id: 'Spiritual',
    label: 'Spiritual Traveler',
    emoji: '🧘',
    explanation: 'Temples, monasteries, pilgrimage sites and meditation retreats',
  },
  {
    id: 'Animal',
    label: 'Animal Lover',
    emoji: '🐾',
    explanation: 'Wildlife-rich habitats, safaris, marine life, birdwatching, conservation zones',
  },
  {
    id: 'Food',
    label: 'Foodie',
    emoji: '🍽️',
    explanation: 'Food markets and food festivals',
  },
];

export interface CountryEntry {
  iso: string;
  id: number;
}

export interface DuplicateSightseeingPost {
  representative_id: number;
  countries: CountryEntry[];
}

export interface HandleDuplicateSightseeingPostsProps {
  post: DuplicateSightseeingPost;
  toggleButtonRef: React.MutableRefObject<HTMLDivElement | null>;
  openPanel: number | null;
  setOpenPanel: React.Dispatch<React.SetStateAction<number | null>>;
}

export const HandleDuplicateSightseeingPosts = ({ post, toggleButtonRef, openPanel, setOpenPanel }: HandleDuplicateSightseeingPostsProps) => {
  const navigate = useNavigate();
  const [resolvedNames, setResolvedNames] = useState<Record<string, string>>({});

  useEffect(() => {
    const resolveNames = async () => {
      if (openPanel === post.representative_id && post.countries.length > 0) {
        const names: Record<string, string> = {};
        for (const entry of post.countries) {
          const name = await FetchCountryName(entry.iso);
          names[entry.iso] = name;
        }
        setResolvedNames(names);
      }
    };

    resolveNames();
  }, [openPanel, post]);

  return (
    <div>
      {post.countries.length > 1 && (
        <div
          className="duplicate-indicator"
          ref={toggleButtonRef}
          onClick={(e) => {
            e.stopPropagation();
            setOpenPanel((prev) => (prev === post.representative_id ? null : post.representative_id));
          }}
        >
          🔁 View in other countries
        </div>
      )}

      {openPanel === post.representative_id && (
        <div className="slide-in-panel">
          <h2>Also appears in:</h2>
          <ul>
            {post.countries.map((entry) => (
              <li key={entry.iso}>
                <button
                  onClick={async () => {
                    try {
                      const countryName = await FetchCountryName(entry.iso);
                      const pageResponse = await axios.get(`${backendUrl}/worlddata/sightseeing/get-cursor-for-item/${entry.id}/9/?iso=${entry.iso}`);
                      const cursor = pageResponse.data.cursor;
                      const cursorToken = pageResponse.data.cursor_token || '';
                      navigate(`/traveltopics/${countryName}/topics/sightseeing`, {
                        state: {
                          selectedItemId: entry.id,
                          selectedItemCursor: cursor,
                          selectedItemCursorToken: cursorToken,
                          category: '',
                        },
                      });
                    } catch (error) {
                      console.error('Error navigating to food item from latest page through a representative item:', error);
                    }
                  }}
                >
                  {resolvedNames[entry.iso] || entry.iso}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
